module.exports = __webpack_public_path__ + "img/attachmentSetting-1.272210b.webp";